// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e7124e00","239":"859f8ebc","455":"343101e6"}[chunkId] + ".chunk.js";
};